import React, {useState} from 'react';
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import {useAdminBucket } from "../../../components/utils";
import {useControlledTabs} from "../../../components/Tabs";
import {Icon, Title} from "../../../components/components";
import FormButton from "../../../components/forms/FormButton";
import AudienceForm from "../../../components/data_products/audiences/AudienceForm";
import {
  useGetDataVendorAudienceAggregationOptionsQuery,
  useGetDataVendorAudienceQuery, useGetDataVendorAudiencesQuery,
  useRunDataVendorAudienceMutation
} from "../../../api/dataVendorAudienceApiSlice";
import useRunExtract from '../../../components/data_products/useRunExtract';

export default function DataVendorAudience(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const { dataVendorKey, audienceId } = useParams();
  const { data: audience, isSuccess } = useGetDataVendorAudienceQuery([dataVendorKey, audienceId])
  const [run] = useRunDataVendorAudienceMutation()
  const bucket = useAdminBucket(dataVendorKey)
  const [audienceLaunching, setAudienceLaunching] = useState(false);
  const { data: aggregationOptions = [] } = useGetDataVendorAudienceAggregationOptionsQuery(dataVendorKey)
  const { data: audiences = [] } = useGetDataVendorAudiencesQuery(dataVendorKey)
  const [tabProps, setActiveTab] = useControlledTabs("audience", props)
  const handleBack = () => history.push({
    pathname: `/data_vendors/${dataVendorKey}`,
    state: {activeTab: 'audiences'}
  });
  const {extractRuning, runExtract} = useRunExtract( { extractId: audienceId, extract: audience, onStart: ()=>(run([dataVendorKey, audienceId])), onStarted: ()=>(setActiveTab("extract_monitor")) })

  if( !isSuccess ) { return (<></>) }
  return (
    <>
      <Title main={t("menu.audiences")} sub={audience.name} onBack={handleBack} group={false}>
        <FormButton edit state={{activeTab: tabProps.active}}/>
        <Button key="run" onClick={runExtract} disabled={extractRuning}>
          <Icon icon={extractRuning ? 'loading' : 'play'} text={t("extract.run")} />
        </Button>
      </Title>
      <AudienceForm
        disabled
        audience={audience}
        aggregationOptions = {aggregationOptions}
        audiences={audiences}
        bucket={bucket}
        tabProps={tabProps}/>
    </>
  )
}
